import $ from '../lib/jquery';
import { getRecaptcha } from '../lib/recaptcha';

import { Component } from '../core/component';
import { http } from '../core/http';

const contactUrl = '/actions/contact-form/send';

export class ContactForm extends Component {
    selector = '.js-contact-form';

    grecaptcha = null;

    async init() {
        this.grecaptcha = await getRecaptcha();

        this.$elements.each((index, element) => {
            this.setupForm(element);
        });
    }

    setupForm(form) {
        const $form = $(form);

        const recaptchaEl = $form.find('.g-recaptcha')[0];
        const recaptchaId = this.grecaptcha.render(
            recaptchaEl,
            {
                callback: (token) => {
                    this.submit(form, token);
                },
            },
            true,
        );

        $form.on('submit', (evt) => {
            evt.preventDefault();

            this.grecaptcha.execute(recaptchaId);
        });
    }

    submit(form, token) {
        const data = {
            fromEmail: form.email.value,
            fromName: form.name.value,
            subject: form.subject.value,
            message: form.message.value,
            'g-recaptcha-response': token,
        };

        http.post(contactUrl, data).then(() => {
            // custom FormData cause of the newsletter checkboxes
            const $fd = new FormData(form);

            const selectedCheckboxes = $(form).find('.js-newsletter-checkboxes:checked').toArray();
            if (selectedCheckboxes.length) {
                $fd.set('audiences', this.formatIds(selectedCheckboxes));
            }

            fetch('/mailchimp/send', {
                method: 'post',
                body: $fd,
            })
                .then(() => {
                    window.location.href = form.redirect.value;
                });
        }).catch(() => {
            // eslint-disable-next-line no-alert
            window.alert('There was an error submitting the form. Please try again later');
        });
    }

    formatIds(checkboxes) {
        return checkboxes
            .map(checkbox => checkbox.value)
            .join('|');
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/ContactForm.js